import store from "../store";

const CUSTOMER_PREFIX = "/connect/aluno";
const PARTNER_PREFIX = "/connect/professor";
// Telas liberadas mesmo com o cadastro incompleto.
const ALLOWED_WHEN_PENDING = [
  `${CUSTOMER_PREFIX}/perfil`,
  `${CUSTOMER_PREFIX}/completar-informacoes`,
];

export default async (to, from, next) => {
  if (to.name != from.name) window.scrollTo(0, 0);

  const requiredAuth = to.meta.authRequired ?? false;
  const preventAuth = to.meta.preventAuth ?? false;

  const authenticated = !!store.getters.token;

  if (requiredAuth && !authenticated) return next("/connect");
  if (preventAuth && !authenticated) return next("/connect");

  // Cada sessao so entra na propria area. Aluno em /connect/professor (ou o
  // contrario) dispara as chamadas da API do outro perfil, que respondem 401,
  // e o baseApi desloga -- foi o que derrubava o aluno sem turma no login
  // (card 86akj7g9k, retorno de 07/10). Rotas com nome repetido nas duas areas
  // ("Perfil", "Curso", "Turmas"...) resolvem para a do professor.
  if (authenticated) {
    const module = store.getters.module;
    if (module === "aluno" && to.path.startsWith(PARTNER_PREFIX)) {
      return next(`${CUSTOMER_PREFIX}/cockpit`);
    }
    if (module === "professor" && to.path.startsWith(CUSTOMER_PREFIX)) {
      return next(`${PARTNER_PREFIX}/cockpit`);
    }
  }

  // Bloqueia o uso da plataforma por alunos com cadastro incompleto (inseridos
  // pelo admin, sem nivelamento/preferencias) ate completarem as informacoes.
  const user = store.getters.user;
  if (
    authenticated &&
    store.getters.module === "aluno" &&
    to.path.startsWith(CUSTOMER_PREFIX) &&
    user &&
    user.pendingInfo &&
    !ALLOWED_WHEN_PENDING.includes(to.path)
  ) {
    return next(`${CUSTOMER_PREFIX}/completar-informacoes`);
  }

  // Aluno solo (preference ALONE = 1) nao tem fluxo de turmas/match: redireciona
  // qualquer acesso direto a rota de Turmas para os modulos.
  if (
    authenticated &&
    store.getters.module === "aluno" &&
    to.path === `${CUSTOMER_PREFIX}/turmas` &&
    user &&
    // preference e INT8 e chega como string ("1"): `=== 1` nunca casava.
    Number(user.preference) === 1
  ) {
    return next(`${CUSTOMER_PREFIX}/curso`);
  }

  document.title = to.name + "- Pitch Connect";

  next();
};
